import React from 'react';
import { BlogHeader, FilterButtons, Latest } from '../components/placement';
import { PlacementProvider } from '../context/usePlacementContext';
import { ScrollArea } from '../components/ui/scroll-area';

function Placement() {
  return (
    <PlacementProvider>
      <ScrollArea className="h-full px-2 sm:px-7 pb-3">
        <div className="md:px-20">
          <BlogHeader />
          <FilterButtons />
        </div>
        <div className="md:px-20">
          <Latest />
        </div>
      </ScrollArea>
    </PlacementProvider>
  );
}

export default Placement;
